
import { IDateRange } from '@containers/calendar/calendar.helpter';
import { ISchedule, IScheduleEntry } from '@app-types/websocket/schedule.types';
import { IHandoverSetting, createArrayCopyAndSort, createScheduleSide, mergeAndClean } from '../ScheduleCalc';

const applyChanges = (schedule:ISchedule, selectedDays:IDateRange[], pickupParentA:IHandoverSetting[], 
  dropoffParentA:IHandoverSetting[], pickupParentB:IHandoverSetting[], dropoffParentB:IHandoverSetting[]):ISchedule => {

  const newSchedule:ISchedule = {
    id:schedule.id,
    lastHandover:schedule.lastHandover,
    status:schedule.status,
    name:schedule.name,
    school:schedule.school,
    data:{
      children:schedule.data.children,
      parentA:schedule.data.parentA,
      parentB:schedule.data.parentB,
      scheduleEntriesParentA:schedule.data.scheduleEntriesParentA,
      scheduleEntriesParentB:schedule.data.scheduleEntriesParentB,
    }
  }


  const modifiedEntries = addVisitDays(
    createArrayCopyAndSort(schedule.data.scheduleEntriesParentA),
    createArrayCopyAndSort(schedule.data.scheduleEntriesParentB),
    pickupParentA, dropoffParentA, pickupParentB, dropoffParentB,
    selectedDays);

  newSchedule.data.scheduleEntriesParentA = createScheduleSide(mergeAndClean(modifiedEntries.sideA));
  newSchedule.data.scheduleEntriesParentB = createScheduleSide(mergeAndClean(modifiedEntries.sideB));

  return newSchedule;
}

const addVisitDays = (sideA:IScheduleEntry[], sideB:IScheduleEntry[], 
  pickupParentA:IHandoverSetting[], dropoffParentA:IHandoverSetting[], pickupParentB:IHandoverSetting[], dropoffParentB:IHandoverSetting[],
  selectedDays:IDateRange[])
  :{sideA:IScheduleEntry[], sideB:IScheduleEntry[]} => {
    // find unused id for side A  and B
    let idA = 1;
    if (sideA.length > 0) {
      idA = sideA.reduce((prev, current) =>  ((prev && prev.id > current.id) ? prev : current)).id+1;
    }
    let idB = 1;
    if (sideB.length > 0) {
      idB = sideB.reduce((prev, current) =>  ((prev && prev.id > current.id) ? prev : current)).id+1;
    }


    // create all handover days as individual date ranges
    const handoverDays:IDateRange[] = [];
    const oneDay = 1000*60*60*25;

    for (const selection of selectedDays) {
      let start = selection.start
      while (start < selection.end) {
        handoverDays.push({
          start,
          end:start+oneDay
        });
        start += oneDay
      }
    }

    const twelveHours = (1000*60*60*12);
    const newSideA:IScheduleEntry[] = [];
    const newSideB:IScheduleEntry[] = [];

    for ( const entry of sideA) {
      for (const selection of handoverDays) {
        if (entry.startTime < selection.start && entry.endTime > selection.end) {
          // a dayvisit should be added lets split this entry

          const pickup = new Date(selection.start+twelveHours);
          pickup.setMilliseconds(0);
          pickup.setSeconds(0);
          pickup.setMinutes(pickupParentB[pickup.getDay()].minute);
          pickup.setHours(pickupParentB[pickup.getDay()].hour);

          const dropoff = new Date(selection.start+twelveHours);
          dropoff.setMilliseconds(0);
          dropoff.setSeconds(0);
          dropoff.setMinutes(dropoffParentB[dropoff.getDay()].minute);
          dropoff.setHours(dropoffParentB[dropoff.getDay()].hour);


          newSideA.push({
            id:idA,
            startTime:entry.startTime,
            startAtSchool:entry.startAtSchool,
            startLoc:entry.startLoc,
            endTime:pickup.getTime(),
            endAtSchool:pickupParentB[pickup.getDay()].atSchool,
            endLoc:pickupParentB[pickup.getDay()].location,
          });

          idA++;

          sideB.push({
            id:idB,
            startTime:pickup.getTime(),
            startAtSchool:pickupParentB[pickup.getDay()].atSchool,
            startLoc:pickupParentB[pickup.getDay()].location,
            endTime:dropoff.getTime(),
            endAtSchool:dropoffParentB[dropoff.getDay()].atSchool,
            endLoc:dropoffParentB[dropoff.getDay()].location,
          });

          idB++;

          entry.startTime = dropoff.getTime();
          entry.startAtSchool = dropoffParentB[dropoff.getDay()].atSchool;
          entry.startLoc = dropoffParentB[dropoff.getDay()].location;
        }
      }
      newSideA.push(entry);
    }

    for ( const entry of sideB) {
      for (const selection of handoverDays) {
        if (entry.startTime < selection.start && entry.endTime > selection.end) {
          // a dayvisit should be added lets split this entry

          const pickup = new Date(selection.start+twelveHours);
          pickup.setMilliseconds(0);
          pickup.setSeconds(0);
          pickup.setMinutes(pickupParentA[pickup.getDay()].minute);
          pickup.setHours(pickupParentA[pickup.getDay()].hour);

          const dropoff = new Date(selection.start+twelveHours);
          dropoff.setMilliseconds(0);
          dropoff.setSeconds(0);
          dropoff.setMinutes(dropoffParentA[dropoff.getDay()].minute);
          dropoff.setHours(dropoffParentA[dropoff.getDay()].hour);


          newSideB.push({
            id:idB,
            startTime:entry.startTime,
            startAtSchool:entry.startAtSchool,
            startLoc:entry.startLoc,
            endTime:pickup.getTime(),
            endAtSchool:pickupParentA[pickup.getDay()].atSchool,
            endLoc:pickupParentA[pickup.getDay()].location,
          });

          idB++;

          newSideA.push({
            id:idA,
            startTime:pickup.getTime(),
            startAtSchool:pickupParentA[pickup.getDay()].atSchool,
            startLoc:pickupParentA[pickup.getDay()].location,
            endTime:dropoff.getTime(),
            endAtSchool:dropoffParentA[dropoff.getDay()].atSchool,
            endLoc:dropoffParentA[dropoff.getDay()].location,
          });

          idA++;

          entry.startAtSchool = dropoffParentA[dropoff.getDay()].atSchool;
          entry.startLoc = dropoffParentA[dropoff.getDay()].location;
          entry.startTime = dropoff.getTime();
        }
      }
      newSideB.push(entry);
    }

    newSideA.sort((a,b) => a.startTime - b.startTime);
    newSideB.sort((a,b) => a.startTime - b.startTime);

    return {sideA:newSideA, sideB:newSideB};
}

// returns an array with 7 entries with a count on the number of handovers occuring that day ( 0 = sunday )
const calculateHandoverDays = (selectedDays:IDateRange[], schedule:ISchedule|undefined)
  :{daysParentA:number[], daysParentB:number[]} => {
    const parentA:number[] = [0,0,0,0,0,0,0];
    const parentB:number[] = [0,0,0,0,0,0,0];

    const handoverDays:IDateRange[] = [];
    const oneDay = 1000*60*60*25;

    for (const selection of selectedDays) {
      let start = selection.start
      while (start < selection.end) {
        handoverDays.push({
          start,
          end:start+oneDay
        });
        start += oneDay
      }
    }
    
    if (schedule !== undefined) {

      let side = createArrayCopyAndSort(schedule.data.scheduleEntriesParentA);

      for ( const entry of side) {
        for (const selection of handoverDays) {
          if (entry.startTime < selection.start && entry.endTime > selection.end) {
            const pickup:Date = new Date((selection.start + selection.end) / 2);
            parentB[pickup.getDay()] = parentB[pickup.getDay()]+1;
          }
        }
      }

      side = createArrayCopyAndSort(schedule.data.scheduleEntriesParentB);

      for ( const entry of side) {
        for (const selection of handoverDays) {
          if (entry.startTime < selection.start && entry.endTime > selection.end) {
            const pickup:Date = new Date((selection.start + selection.end) / 2);
            parentA[pickup.getDay()] = parentA[pickup.getDay()]+1;
          }
        }
      }

    }

    return {daysParentA:parentA,daysParentB:parentB};
  }

export { calculateHandoverDays, applyChanges };



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/Dayvisit/DayvisitCalc.ts